import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/services/base.service';
import { DOC_STATE, PDF_CA, PDF_SLA } from 'src/app/constants/endpoint.const';
import { Subject, takeUntil } from 'rxjs';
import { DocumentStateResponseType } from 'src/app/types/response/document-state.response.type';
import { NzMessageService } from 'ng-zorro-antd/message';
import { documentConfigs, documentDotStatusMap, documentStatusMap } from 'src/app/constants/documents.const';
import { DocumentConfigType } from 'src/app/models/documents.model';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  standalone: false,
  selector: 'app-payment-service-document',
  templateUrl: './payment-service.component.html',
  styleUrl: './payment-service.component.scss'
})
export class PaymentServiceDocumentComponent {
  loading: boolean = true;
  destroy$ = new Subject();
  docSLA: string = '';
  docCA: string = '';
  docUAT: string = '';
  roLevel: string = '';

  documentConfigs: DocumentConfigType[] = documentConfigs;
  @Input() docState: DocumentStateResponseType[] = [];
  @Output() stateUpdated = new EventEmitter<void>();

  constructor(
    private router: Router,
    private BaseService: BaseService,
    private message: NzMessageService,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.roLevel = String(this.profileService.getRoLevel() || '');
    this.profileService.getRoLevel$().subscribe((lvl) => {
      this.roLevel = String(lvl || '');
    });
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  handleAction(config: DocumentConfigType, mode: string) {
    const { route, type } = config;
    
    if (type === 'CA' && mode === 'create') {
      const slaState = this.getStateByType('SLA');
      if (!slaState || slaState.current_state === 1) {
        this.message.error('Please fill in SLA data first');
        return;
      }
    }

    localStorage.setItem(`mode-${type.toLowerCase()}-input`, mode);
    localStorage.setItem('service_type_doc', 'payment');

    const queryParams: Record<string, string | number> = { service_type: 'payment' };

    if (type === 'SLA' || type === 'UAT') {
      queryParams['step'] = 1;
    }

    if (mode === 'edit' && type !== 'UAT') {
      queryParams['mode'] = mode;
    }

    this.router.navigate([route + (type === 'UAT' ? '-payment' : '')], { queryParams });
  }

  sendDoc(type: string) {
    const route = type === 'SLA' ? '/document/submission-sla' : '/document/submission-ca';
    this.router.navigate([route + (type === 'UAT' ? '-payment' : '')], { queryParams: { service_type: 'payment' } });
  }


  downloadPdf(v: string) {
    const url = v === 'SLA' ? PDF_SLA : PDF_CA;
    this.BaseService.getData(url + '?service_types_id=2')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: {data: {uploaded_file_path: string}}) => {
          this.docSLA = res.data.uploaded_file_path;
          window.open(this.docSLA, '_blank');
          this.updateState(v);
        },
        error: () => {
          this.message.error('The document is still in progress or has not been inputted yet');
        }
      });
  }

  getStateByType(type: string): DocumentStateResponseType | undefined {
    return this.docState.find((s) => s.document_type === type);
  }

  updateState(v: string): void {
    const params = {
      document_type: v,
      state: 3,
    };
    this.BaseService.putData(DOC_STATE, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.stateUpdated.emit();
        },
        error: (err) => {
          this.message.error(err.error.meta.message || 'Failed to update document state');
        }
      });
  }

  handleStatus(v: number | undefined) {
    return (v !== undefined && documentStatusMap[v]) || '';
  }

  handleDotStatus(v: number | undefined) {
    return (v !== undefined && documentDotStatusMap[v]) || '';
  }
}
